import EastIcon from "@mui/icons-material/East";
import { Button, Divider, IconButton, Stack, Typography } from "@mui/material";
import IOSSwitch from "../NotificationsSetting/IOSSwitch";
import LanguageDropdown from "./LanguageDropdown";
const generalPreferencesData = [
  {
    title: "General Preferences",
    settingTexts: [
      { text: "Language", dropdown: true, alignSelf: true },
      { text: "AutoPlay Videos", toggleButton: true },
      { text: "Sound Effects" },
      { text: "Showing Profile Photos" },
      { text: "Preferred Feed View" },
      { text: "People you Unfollowed" },
      { text: "Help Center" },
    ],
  },
  { title: "Account Management", settingTexts: [{ text: "Logout" }] },
];

function GeneralPreferencesSection() {
  return (
    <Stack spacing={2}>
      {generalPreferencesData.map((setting) => (
        <Stack
          sx={{
            bgcolor: "#ffffff",
            borderRadius: "22px",
            p: "20px",
            position: "relative",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "20px",
              fontWeight: "600",
              lineHeight: "24.2px",
            }}
          >
            {setting.title}
          </Typography>
          {setting.settingTexts.map((settingText) => (
            <>
              {" "}
              <Divider
                sx={{
                  height: "1px",
                  bgcolor: "#EBEBEB",
                  border: "none",
                  mx: "-20px",
                  my: "16px",
                }}
              />
              <Stack
                direction="row"
                sx={{
                  alignItems: "center",
                  justifyContent: "space-between",
                  position: "relative",
                }}
              >
                {" "}
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "18px",
                    fontWeight: "400",
                    lineHeight: "21.78px",
                    alignSelf: settingText.alignSelf ? "start" : "",
                  }}
                >
                  {settingText.text}
                </Typography>
                {settingText.toggleButton ? (
                  <IOSSwitch />
                ) : settingText.dropdown ? (
                  <LanguageDropdown />
                ) : (
                  <IconButton sx={{ p: "0px" }}>
                    <EastIcon sx={{ color: "#000000" }} />
                  </IconButton>
                )}
              </Stack>
            </>
          ))}
        </Stack>
      ))}
    </Stack>
  );
}

export default GeneralPreferencesSection;
